<div class="-oneX-container">
    <div class="-oneX-container">
        <div class="-oneX-row">
            <div class="-oneX-heading--h2">Claim Not Found</div>
        </div>

    </div>
    <hr>
    <div class="-oneX-container">
        <div class="-oneX-row">
            <div class="-oneX-body--primary">Based on the information provided below, there weren't any matching claims.
            </div>
        </div>
    </div>
    <br>
    <div class="-oneX-container">
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-container">
                <app-claim-information></app-claim-information>
            </div>
        </div>
        <hr>
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-container">
                <app-search-another-claim></app-search-another-claim>
            </div>
        </div>
    </div>
</div>